export function uniqBy<T extends object>(array: T[], key: keyof T) {
  return array.filter((a, i, arr) => {
    return !arr.slice(0, i).some((b) => {
      if (a[key]?.call) {
        return a[key]() === b[key]()
      }
      return a[key] === b[key]
      })
  })
}
